/**
 * Referral Campaign Management Types
 * TypeScript interfaces for referral campaign rules and related entities
 */

import { ApiResponse, Pageable, PagedData } from './types';

// Referral Campaign type based on ReferralCampaignDTO from Swagger
export interface ReferralCampaign {
  referralCampaignId: number;
  referralCampaignName?: string;
  referrerRewardType: string;
  referrerRewardValue: number;
  referredRewardType: string;
  referredRewardValue: number;
  validityDays: number;
  maxUsesPerReferrer: number;
  isActive: boolean;
  createdBy?: string;
  createdDate?: string;
  isDeletedValue?: boolean;
  modifiedBy?: string;
  modifiedDate?: string;
}

// DTO types for API requests
export type ReferralCampaignDTO = Omit<ReferralCampaign, 'referralCampaignId' | 'createdDate' | 'modifiedDate'> & {
  referralCampaignId?: number;
};

// Query parameters for listing
export interface ReferralCampaignListQueryParams {
  page?: number;
  size?: number;
  sort?: string[];
  search?: string;
  isActive?: boolean;
  referrerRewardType?: string;
  referredRewardType?: string;
  validityDays?: number;
}

// Status options
export type StatusOption = 'all' | 'active' | 'inactive';

// Reward type options
export type RewardTypeOption = 'all' | 'DISCOUNT' | 'CASHBACK' | 'CREDIT' | 'FREE_RIDE' | 'POINTS';

// Referral campaign statistics
export interface ReferralCampaignStats {
  totalReferralCampaigns: number;
  activeReferralCampaigns: number;
  inactiveReferralCampaigns: number;
  averageValidityDays: number;
  averageReferrerReward: number;
  averageReferredReward: number;
}

// Form validation schema
export interface ReferralCampaignForm {
  referralCampaignName: string;
  referrerRewardType: string;
  referrerRewardValue: number;
  referredRewardType: string;
  referredRewardValue: number;
  validityDays: number;
  maxUsesPerReferrer: number;
  isActive: boolean;
}

// Validation errors interface
export interface ReferralCampaignFormErrors {
  referralCampaignName?: string;
  referrerRewardType?: string;
  referrerRewardValue?: string;
  referredRewardType?: string;
  referredRewardValue?: string;
  validityDays?: string;
  maxUsesPerReferrer?: string;
}

// Export constants for dropdown options
export const REWARD_TYPES = [
  { value: 'DISCOUNT', label: 'Discount (%)' },
  { value: 'CASHBACK', label: 'Cashback (USD)' },
  { value: 'CREDIT', label: 'Account Credit (USD)' },
  { value: 'FREE_RIDE', label: 'Free Ride' },
  { value: 'POINTS', label: 'Loyalty Points' }
];

export const STATUS_OPTIONS = [
  { value: 'all', label: 'All Status' },
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' }
];

// Re-export from pricing types for consistency
export type { ApiResponse, PagedData } from './types';